import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useCornTechnologies } from '/@/hooks/catalog';
import { _ } from '/@/locale';
import { resetProductSelection, setTechnology } from '/@/store/catalog/actions';
import { setSelectedFeature } from '/@/store/nav/actions';
import { trackEvent } from '/@/store/tracking';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import styles from '../styles.module.css';

interface WarningNotificationProps {
    /** Marks the warning as read (persists dismissal). */
    handleCloseIconNotification: () => void;
    /** Closes the surrounding container (popover/card), when present. */
    closePopover?: () => void;
}

const WarningNotification = ({ handleCloseIconNotification, closePopover }: WarningNotificationProps) => {
    const history = useNavigate();
    const dispatch = useDispatch();

    const technologiesCornQuery = useCornTechnologies({ page: 1, pageSize: 10000 });
    const technologies = (technologiesCornQuery.data?.results || []).filter((t) => t.displayInCatalog);

    const handleClick = () => {
        dispatch(trackEvent({ key: 'notifications.vtPro4', open: true }));
        handleCloseIconNotification();
        const data = { view: 'catalog.Biotechnology', selectedFeature: 'datalog', crop: 'corn' };
        dispatch(setSelectedFeature(data));
        dispatch(resetProductSelection());
        const technology = technologies.find((tech) => tech.name === 'VTPRO4');
        if (technology) {
            dispatch(setTechnology(technology.id));
        }
        closePopover?.();
        history(
            reverse('catalog.Biotechnology', {
                params: { type: 'corn' },
            })
        );
    };

    return (
        <Grid container direction='column' sx={{ p: 2, width: '100%', bgcolor: '#d44e21' }}>
            <Grid item xs={12} sx={{ pb: 1 }}>
                <Grid container direction='row' justifyContent='flex-start' alignItems='center'>
                    <Grid item sx={{ mr: 1 }}>
                        <i className={classNames('material-icons', styles.iconInfo)}>info</i>
                    </Grid>
                    <Grid item sx={{ mb: '4px' }}>
                        <Title color='white' className={styles.titleWarning}>
                            {_('VTPRO4 - IMPORTANTE')}
                        </Title>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sx={{ pb: 1 }}>
                <Title color='white' className={styles.textWarning}>
                    {_(
                        'Recordá que si el híbrido que sembraste tiene tecnología VTPRO4, no podes aplicar productos a base de glifosato a partir de V6'
                    )}
                </Title>
            </Grid>
            <Grid item xs={12} sx={{ pb: 1 }}>
                <Button variant='outlined' fullWidth color='error' onClick={handleClick}>
                    {_('Ver más')}
                </Button>
            </Grid>
        </Grid>
    );
};

export default WarningNotification;
